import { useCallback } from 'react'
import { Stack } from 'syf-component-library/ui/spacing'
import { CustomBrandComponents } from 'typings/brands'
import {
  BusinessHoursGrid,
  Header,
  SectionTitle,
  Text
} from 'ui/molecules/NeedAssistance/subcomponents'
import Superscriptify from 'ui/atoms/Superscriptify'
import { REGISTERED_TRADEMARK } from 'const/text'
import { translations } from '../brandTranslations'
import customerSupport from '../customerSupport'
import clientInfo from '../clientInfo'

const CustomNeedAssistanceContent: CustomBrandComponents['CustomNeedAssistanceContent'] =
  ({ i18n }) => {
    const translate = useCallback(
      (key: string) => i18n({ customNeedAssistance: key }, {}, translations),
      [i18n]
    )

    return (
      <>
        <Header>
          <Superscriptify target={REGISTERED_TRADEMARK}>
            {clientInfo.displayName}
          </Superscriptify>{' '}
          {translate('Commercial Credit Card Services')}
        </Header>
        <SectionTitle>
          <Superscriptify target={REGISTERED_TRADEMARK}>
            {clientInfo.displayName}
          </Superscriptify>{' '}
          {translate('Commercial Credit Card')}
        </SectionTitle>
        <Text>{customerSupport.contactUsBrc}</Text>
        <Stack />
        <SectionTitle>{i18n({ needAssistance: 'businessHours' })}</SectionTitle>
        <BusinessHoursGrid>
          <span>{translate('Monday - Friday')}</span>
          <span>{translate('08:00 AM - 01:00 AM EST')}</span>
          <span>{translate('Saturday & Sunday')}</span>
          <span>{translate('09:00 AM - 10:00 PM EST')}</span>
        </BusinessHoursGrid>
      </>
    )
  }

export default CustomNeedAssistanceContent
